import { useEffect, useState } from "react";
import {
  AttachmentField,
  Button,
  Chip,
  Divider,
  DocumentsList,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { useAttachmentHandlers } from "../../../../../hooks/useAttachmentHandlers";
import { filterEmptyValues } from "../../../../../utils/filterEmptyValues";
import { v4 as uuidv4 } from "uuid";
import {
  addNewImmigrationsStart,
  getAllImmigrations,
  getAllImmigrationsStart,
} from "../../../../../redux/slices/immigration/immigrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { uploadStart } from "../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../redux/slices/universal/documentsSlice";
// import {
//   getEmployeeByUiidStart,
//   getEmployeesStart,
// } from "../../../../../../redux/slices/employee/employeeSlice";
import { usePagination } from "../../../../../hooks";
import { countryListOptions } from "../../../../../assets/data/projectData";
import {
  getEmployeeByUiidStart,
  getEmployeesStart,
} from "../../../../../redux/slices/employee/employeeSlice";
import { VisaType, RecordStatus } from "../../../../../assets/data/enumData";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
const AddVisaModal = ({
  isOpen,
  onClose,
  immigrationsTableData,
  editData,
  isEditMode = false,
  page,
  limit,
}) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const defaultValue = {
    country: "",
    visaType: "",
    visaStatus: "",
    consularLocation: "",
    dsNumber: "",
    visaInterviewDate: "",
    petitioner: "",
    receiptNumber: "",
    petitionEndDate: "",
    status: "",
    issueDate: "",
    expirationDate: "",
    attachmentName: "",
    attachmentComments: "",
    employeeId: "",
    // attachments: [],
    attachments: [
      {
        id: uuidv4(),
        attachmentName: "",
        attachmentComments: "",
        file: null,
      },
    ],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValue, {
      country: { type: "select", required: true },
      employeeId: { type: "select", required: true },
      attachments: [
        {
          attachmentName: {
            type: "text",
            required: true,
            minLength: 3,
          },
          //attachmentComments: { type: "text", required: true },
          chooseFiles: { type: "file", required: true },
        },
      ],
    });
  const [attachmentModal, setAttachmentModal] = useState(false);
  const { renderAttachments } = useAttachmentHandlers(
    formData,
    handleChange,
    errors,
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const visa = {
        country: formData.country,
        type: formData.visaType,
        visaStatus: formData.visaStatus,
        consularLocation: formData.consularLocation,
        ds160Num: formData.dsNumber,
        interviewDate: formData.visaInterviewDate,
        petitioner: formData.petitioner,
        receiptNum: formData.receiptNumber,
        petitionEndOn: formData.petitionEndDate,
        status: formData.status,
        approvalDetails: {
          issueDate: formData.issueDate,
          expiryDate: formData.expirationDate,
        },
      };
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0),
      );
      const cleanattachmentsId = cleanAttachments.flatMap((doc) =>
        doc.chooseFiles.map((file) => {
          file.id = doc.id;
          return file;
        }),
      );
      const submissionData = filterEmptyValues(visa);
      dispatch(
        addNewImmigrationsStart({
          uiid: editData?.uiid || "",
          coll: "Visa",
          tPath: "visa",
          rsd: submissionData,
          rsn: "visa",
          payload: editData?.uiid
            ? [
                {
                  type: "SET",
                  value: {
                    addedBy: loginUserUiid,
                    ...submissionData,
                  },
                },
              ]
            : {
                addedBy: loginUserUiid,
                employeeId: formData.employeeId?.value ?? formData?.employeeId,
                ...submissionData,
              },
          onSuccess: async (payload) => {
            const delay = (ms) => new Promise((res) => setTimeout(res, ms));
            if (cleanattachmentsId.length > 0) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: formData.employeeId?.value ?? formData?.employeeId,
                  entity: "visas",
                  category: "visas",
                  coll: "Visa", //WorkAuth
                  doc: cleanattachmentsId,
                  onSuccess: async (fileData) => {
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Visa",
                        refId:
                          payload.data.data.visaId ||
                          payload.data.data.doc.uiid,
                        refField: "approvalDetails.attachments",
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              parent: {
                                employee:
                                  formData.employeeId?.value ??
                                  formData.employeeId,
                              },
                              addedBy: loginUserUiid,
                              docType: "Visa",
                              ref: {
                                id:
                                  payload.data.data.visaId ||
                                  payload.data.data.doc.uiid, // parent doc uiid this doc belongs to
                                entity: "Visa", // collection name this doc belongs to
                                path: `approvalDetails.attachments`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        onSuccess: async () => {
                          await dispatch(
                            totalCountStart({
                              collection: "visas",
                              coll: "Visa",
                              tname: "visa",
                            }),
                          );
                          await delay(300); // Delay 300ms after first

                          await dispatch(
                            getAllImmigrations({
                              coll: "Visa",
                              rsn: "visa",
                              limit: limit || 10,
                              page: page || 1,
                              ref: "Employee Document",
                              incl: ["uiid firstName"],
                            }),
                          );
                          onClose();
                        },
                      }),
                    );
                  },
                }),
              );
            } else {
              await dispatch(
                totalCountStart({
                  collection: "visas",
                  coll: "Visa",
                  tname: "visa",
                }),
              );
              await delay(300); // Delay 300ms after first

              await dispatch(
                getAllImmigrations({
                  coll: "Visa",
                  rsn: "visa",
                  limit: limit || 10,
                  page: page || 1,
                  ref: "Employee",
                  incl: ["uiid firstName"],
                }),
              );
              onClose();
            }
          },
        }),
      );
      console.log("form data is :", formData);
    } else {
      showToast("Please fill the all required fields");
    }
  };
  console.log("isOpen", isOpen);
  useEffect(() => {
    if (editData && isEditMode) {
      setFormData({
        ...formData,
        employeeId: editData?.uiid || "",
        country: editData?.country || "",
        visaType: editData?.type || "",
        visaStatus: editData?.visaStatus || "Premium",
        consularLocation: editData?.consularLocation || "",
        dsNumber: editData?.ds160Num || "",
        visaInterviewDate: editData?.interviewDate || "",
        petitioner: editData?.petitioner || "",
        receiptNumber: editData?.receiptNum || "",
        petitionEndDate: editData?.petitionEndOn || "",
        status: editData?.status || "",
        issueDate: editData?.approvalDetails?.issueDate || "",
        expirationDate: editData?.approvalDetails?.expiryDate || "",
      });
    } else {
      setFormData(defaultValue);
    }
  }, [editData, setFormData]);

  const combineAttachments = transformFiles(
    editData?.approvalDetails?.attachments || [],
  );
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} title="Visa " width="max-w-7xl">
        <div className=" grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 w-full ">
          <div className="col-span-1 ">
            <FormFieldSet
              type="select"
              title={"Country"}
              placeholder="Select Country"
              value={formData.country}
              onChange={(value) => handleChange("country", value)}
              error={errors.country}
              options={countryListOptions}
            />
          </div>
          <div className="col-span-1">
            <FormFieldSet
              type="select"
              title={"Visa Type"}
              placeholder="Select Visa Type"
              value={formData.visaType}
              onChange={(value) => handleChange("visaType", value)}
              error={errors.visaType}
              options={VisaType}
            />
          </div>
          <div className="col-span-1 ">
            <FormFieldSet
              type="text"
              title={"Visa Status"}
              placeholder="Approved"
              value={formData.visaStatus}
              onChange={(value) => handleChange("visaStatus", value)}
              error={errors.visaStatus}
            />
          </div>
          <div className="col-span-1 ">
            <FormFieldSet
              type="text"
              title={"Consular Location"}
              placeholder="Select City-State"
              value={formData.consularLocation}
              onChange={(value) => handleChange("consularLocation", value)}
              error={errors.consularLocation}
            />
          </div>
          <div>
            <FormFieldSet
              type="text"
              title={"DS-160 Number"}
              placeholder="Enter DS-160 Number"
              value={formData.dsNumber}
              onChange={(value) => handleChange("dsNumber", value)}
              error={errors.dsNumber}
            />
          </div>
          <div>
            <FormFieldSet
              type="datepicker"
              title={"Visa Interview Date"}
              placeholder="Select Visa Interview Date"
              value={formData.visaInterviewDate}
              onChange={(value) => handleChange("visaInterviewDate", value)}
              error={errors.visaInterviewDate}
              showDropdown={false}
            />
          </div>
          <div>
            <FormFieldSet
              type="text"
              title={"Petitioner"}
              placeholder="Enter Petitioner"
              value={formData.petitioner}
              onChange={(value) => handleChange("petitioner", value)}
              error={errors.petitioner}
            />
          </div>
          <div>
            <FormFieldSet
              type="text"
              title={"Receipt Number (1-797)"}
              placeholder="Enter Receipt Number (1-797)"
              value={formData.receiptNumber}
              onChange={(value) => handleChange("receiptNumber", value)}
              error={errors.receiptNumber}
            />
          </div>
          <div>
            <FormFieldSet
              type="datepicker"
              title={"Petition End Date"}
              placeholder="Select Petition End Date"
              value={formData.petitionEndDate}
              onChange={(value) => handleChange("petitionEndDate", value)}
              error={errors.petitionEndDate}
              showDropdown={false}
            />
          </div>
          <div>
            <FormFieldSet
              type="select"
              title={"Status"}
              placeholder="Select Status"
              value={formData.status}
              onChange={(value) => handleChange("status", value)}
              error={errors.status}
              options={RecordStatus}
            />
          </div>
          <div>
            {!isEditMode && (
              <FormFieldSet
                type="employees"
                title="Employee Name"
                placeholder="Enter Employee Name"
                value={formData.employeeId}
                onChange={(value) => {
                  handleChange("employeeId", value);
                }}
                error={errors.employeeId}
                // disabled={isEdit}
                showSearch
              />
            )}
          </div>
        </div>
        <div className="mt-6">
          <h6 className="">Visa approval details</h6>
        </div>
        <Divider />
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 w-full mt-6">
          <div>
            <FormFieldSet
              type="datepicker"
              title={"Issue Date"}
              placeholder="Select Issue Date"
              value={formData.issueDate}
              onChange={(value) => handleChange("issueDate", value)}
              error={errors.issueDate}
              showDropdown={false}
            />
          </div>
          <div>
            <FormFieldSet
              type="datepicker"
              title={"Expiration Date"}
              placeholder="Select Expiration Date"
              value={formData.expirationDate}
              onChange={(value) => handleChange("expirationDate", value)}
              error={errors.expirationDate}
              showDropdown={false}
            />
          </div>
        </div>
        <div className="mt-6">
          <h6 className="">Attachments</h6>
        </div>
        <Divider />

        {renderAttachments(AttachmentField)}
        {editData && (
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => setAttachmentModal(!attachmentModal)}
          >
            <Chip
              label={`Attachments:-${combineAttachments.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        )}
        <div className="flex gap-4 justify-end mt-6">
          <Button
            type="button"
            variant="outlined"
            title="Cancel"
            onClick={onClose}
          />
          <Button type="button" title="Save" onClick={() => handleSave()} />
        </div>
        <Modal
          isOpen={attachmentModal}
          onClose={() => setAttachmentModal(false)}
          // title="Attachment View"
          // width="max-w-5xl"
          width="max-w-2xl"
          title={"Document Details"}
        >
          {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
          <DocumentsList data={combineAttachments} />
          {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
          {/* </div> */}
        </Modal>
      </Modal>
    </>
  );
};
export default AddVisaModal;
